module.exports = __webpack_public_path__ + "img/10.272687f5.png";